var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baich" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            width: "80%",
            visible: _vm.dialogVisible,
            "destroy-on-close": "",
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { model: _vm.form, "label-width": "120px", inline: true },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品分类" } },
                [
                  _c("el-cascader", {
                    staticClass: "selWidth mr20",
                    attrs: {
                      options: _vm.merCateList,
                      props: _vm.props,
                      clearable: "",
                      size: "small",
                    },
                    on: { change: _vm.search },
                    model: {
                      value: _vm.form.cateId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cateId", $$v)
                      },
                      expression: "form.cateId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.form.skuName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "skuName", $$v)
                      },
                      expression: "form.skuName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "SKU编码" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.form.skuCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "skuCode", $$v)
                      },
                      expression: "form.skuCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品品牌" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth mr20",
                      attrs: {
                        placeholder: "请选择",
                        filterable: "",
                        remote: "",
                        clearable: "",
                        "remote-method": _vm.brandRemoteMethod,
                        size: "small",
                      },
                      model: {
                        value: _vm.form.brandId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "brandId", $$v)
                        },
                        expression: "form.brandId",
                      },
                    },
                    _vm._l(_vm.brandList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.brandWording, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品供应商" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "selWidth mr20",
                      attrs: {
                        placeholder: "请选择",
                        filterable: "",
                        remote: "",
                        clearable: "",
                        "remote-method": _vm.remoteMethod,
                        size: "small",
                      },
                      model: {
                        value: _vm.form.supplierId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "supplierId", $$v)
                        },
                        expression: "form.supplierId",
                      },
                    },
                    _vm._l(_vm.suppliers, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.supplierName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.search },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "tableRef",
              attrs: { data: _vm.tableData.list, "row-key": "id" },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  "reserve-selection": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "id", label: "ID" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuCode", label: "编码" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuName", label: "名称", width: "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "otPrice", label: "零售价(原价)", width: "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "defaultPrice",
                  label: "默认售价",
                  width: "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "listStatus", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              scope.row.listStatus == 1 ? "success" : "danger",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              { 0: "未上架", 1: "已上架" }[scope.row.listStatus]
                            )
                          ),
                        ]
                      )
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "supplierName", label: "供应商" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "page-sizes": [20, 40, 60, 80],
              "page-size": _vm.pageFrom.limit,
              "current-page": _vm.pageFrom.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确认选择")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "info" }, on: { click: _vm.close } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }